<script type="text/jsx">
import mixin from '@/plans/mx/shopping-cart';
import mxPlanConfig from '@/plans/VIDEO_SDK_UC/mixin';
import { getPlanUnitWithQuantity, planUnitMap } from '@/common/product-unit';

export default {
  mixins: [mixin, mxPlanConfig],
  name: 'SDKUCCart',
  methods: {
    $renderPrice() {
      if (!this.mx_plans.length) return;
      return (
        <div class="opc-cart-item">
          {this.mx_plans.map((plan) => {
            return (
              <div>
                {this.mx_title(this.title, this.mx_price(plan))}
                {this.mx_license(plan?.credit, getPlanUnitWithQuantity(planUnitMap.credits))}
                {this.mx_cycle(plan.billing_cycle)}
                {this.mx_edit(plan)}
              </div>
            );
          })}
        </div>
      );
    },
  },
};
</script>
